<!--
  - SPDX-FileCopyrightText: 2015 Nextcloud GmbH and Nextcloud contributors
  - SPDX-License-Identifier: AGPL-3.0-or-later
-->
<template>
	<span :aria-hidden="!title"
		:aria-label="title"
		class="material-design-icon osm-icon"
		role="img"
		v-bind="$attrs"
		@click="$emit('click', $event)">
		<svg
			:fill="fillColor"
			:width="size"
			:height="size"
			enable-background="new 0 0 512 512"
			version="1.1"
			viewBox="0 0 512 512"
			xml:space="preserve"
			xmlns="http://www.w3.org/2000/svg">
			<path d="M57,511.4c-7.5-1.9-11.4-5-31.4-24.9C1.8,462.7,0.3,460.3,0.4,448c0-13.8-4.3-8.8,71.8-85.1c76.7-76.9,72.8-73.6,86.7-73.6
				c6.5,0,8.1,0.3,13.3,3l5.9,3l37.2-37.2l-4.7-7.3c-9-14.2-17.6-34.8-21.4-51.8c-10.8-48.3,0.8-98.8,31.6-137.4
				c53.1-66.5,148.4-81.3,218.8-33.8c38.7,26,63.9,66.1,71,113.3c1.5,10,1.5,33.7,0,44.3c-4.8,35.6-21.3,68.7-47,93.9
				c-11.9,12.3-26,22.5-41.5,29.9c-20.4,10.3-37.8,15.1-61.4,17.1c-33.6,2.8-70.8-6.5-99.3-24.8l-7.3-4.7L216.7,334l3,6
				c2.7,5.2,3,6.7,3,13.2c0.1,13.8,3.3,9.9-73.1,86.3c-58.9,58.8-68,67.5-72.5,69.6C71.4,511.8,62.5,512.8,57,511.4z M372.9,297.6
				c42.8-7.9,79.2-35.8,98.3-74.8c29.6-61.9,9.7-134.6-47.6-173C410,40.6,391,32.9,373.1,29.3c-12.3-2.5-38.6-2.2-51.5,0.5
				c-18.8,3.9-36.6,11.6-52.2,22.7c-9.5,6.7-25.2,22.3-31.7,31.7c-36.7,51.3-33.3,121.2,8.1,168.7c21.4,24.7,51,40.8,83.3,45.6
				c10.8,1.7,32.9,1.3,44.1-0.8L372.9,297.6z M293.2,454.9c-15.7-4.3-31.2-9-46.8-13.8l26.8-94.9c0.5-0.6,90.5,24.6,94.2,26.3
				c1.3,0.6-0.1,6.2-11.3,44.8c-4.5,15.9-9,31.9-13.5,47.8c-0.6,1.8-1.5,3.3-2.1,3.3C339.9,468.3,318.6,462.3,293.2,454.9L293.2,454.9
				z M355.4,466.2l26.6-92.8l92.6-25.8l-26.2,93c-0.4,0.4-88,25.4-90.8,26L355.4,466.2z M203.8,425.4c18-18.2,34.1-34.7,35.7-36.9
				c3.6-4.7,8.7-15.6,10.1-21.7c0.6-2.5,1.2-7.5,1.3-11.1l0.3-6.6l3.8-1.1c2.3-0.6,4.2-0.9,4.3-0.8l-26.6,93
				c-0.4,0.3-14.4,4.6-31.3,9.3l-30.3,8.7L203.8,425.4L203.8,425.4z M380.6,360.1l-1.3-4l-1-3.3l3.3-0.6c28.6-4.9,59.3-18.3,83.4-36.5
				c3.4-2.7,5.3-3.7,5.6-2.9c1.1,3.5,5.8,20.2,5.7,20.5L380.6,360.1L380.6,360.1z M58.9,332.3c-1.1-0.8-25.2-82.4-27-91.5
				c-0.3-1.8,3.1-0.9,46.4,11.4c45.2,12.9,46.7,13.4,47.3,15.8c0.7,2.1,0.2,2.8-2.7,4.8c-1.8,1.3-16.4,15.4-32.5,31.5
				c-9.7,9.9-19.6,19.6-29.6,29.2L58.9,332.3L58.9,332.3z M76.4,238.9c-25.3-7.3-46.2-13.3-46.3-13.3l27.4-95.2l95.3,26.8
				c0.2,0.2-5.8,21.7-13.2,47.7c-12.3,43.1-13.8,47.4-15.4,47.3C123.2,252.3,101.7,246.2,76.4,238.9L76.4,238.9z M139.4,250.4
				c0.3-0.7,4.6-15.4,9.5-32.8l8.9-31.4l1.3,6.9c2,11.8,5.7,25.3,9.9,37.1c2.2,6.3,3.9,11.5,3.8,11.7c-0.1,0.2-7.1,2.2-15.3,4.5
				c-8.3,2.3-15.8,4.5-16.8,4.8L139.4,250.4L139.4,250.4z M104.6,130.4c-25.3-7.3-46.3-13.6-46.5-14L31.9,23.9l92.9,26.6l26.6,93.3
				L104.6,130.4L104.6,130.4z M150.5,93.8l-11.1-38.5l-1.7-6L173.8,39c19.9-5.6,36.8-10.5,37.6-10.8c0.7-0.3-1.8,3-5.6,7.2
				c-19.7,21.8-34.1,47.9-41.7,76.2c-1.2,3.9-2.2,7.9-2.8,11.9C161.2,129.8,158.7,123,150.5,93.8L150.5,93.8z" />
		</svg>
	</span>
</template>

<script>
export default {
	name: 'OsmIcon',
	props: {
		title: {
			type: String,
			default: '',
		},
		fillColor: {
			type: String,
			default: 'currentColor',
		},
		size: {
			type: Number,
			default: 24,
		},
	},
	emits: ['click'],
}
</script>
